define(function (require, exports, module) {
    var ContentAudio = require('./ContentAudio');
    var isArray = Array.isArray;

    function ContentAudioList (list) {
        this.parseData(list);
    }

    ContentAudioList.prototype = {
        parseData: function (audio) {
            var cid = this.cid = {};
            var lang = this.language = {};
            var teams = this.teams = {};
            var list = this.list = [];

            if (audio) {
                audio = isArray(audio) ? audio : [audio];
                var item;
                var i = 0;
                var len = audio.length;

                for (; i < len; i++) {
                    item = new ContentAudio(audio[i]);
                    cid[item.id] = item;
                    (lang[item.language] = lang[item.language] || []).push(item);
                    (teams[item.team] = teams[item.team] || []).push(item);
                    list.push(item);
                }
            }

            this.hasAudio = !!list.length;
        }
    };

    return ContentAudioList;
});
